import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=461c4727&scoped=true"
import script from "./Zone.vue?vue&type=script&lang=ts"
export * from "./Zone.vue?vue&type=script&lang=ts"
import style0 from "./Zone.vue?vue&type=style&index=0&id=461c4727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c4727",
  null
  
)

export default component.exports